<template>
    <div>
        <div class="fhv-centent" v-if="!toDhcpReserved">
            <h4 class="title-topic">IPv4 Configuration</h4>
            <el-form 
            :model="lanIPv4Form"  
            label-width="180px" 
            label-position="left"
            class="fhv-form" 
            size="mini"
            v-loading="loading"
            :rules="formCheck" 
            ref="lanIPv4Form"
            :disabled="$G_DEVICE_CFG.isReadOnly"
            >
                <el-form-item label="IP Address :" prop="ipAddr">
                    <el-input v-model="lanIPv4Form.ipAddr"></el-input>
                </el-form-item>
                <el-form-item label="Subnet Mask :" prop="mask">
                    <el-input v-model="lanIPv4Form.mask"></el-input>
                </el-form-item>
                <hr>
                <el-form-item label="" >
                    <el-radio-group v-model="lanIPv4Form.dnsMode">
                        <el-radio label="0" >Use DNS Proxy</el-radio>
                        <el-radio label="2" >Use DNS Relay</el-radio>
                        <el-radio label="1" v-if="isNotShowDNS">Set Manually</el-radio>
                    </el-radio-group>
                </el-form-item>
                <div v-if="lanIPv4Form.dnsMode === '1' && isNotShowDNS" key="DNS">
                    <el-form-item label="Primary DNS Server :" prop="dns1">
                        <el-input v-model="lanIPv4Form.dns1"></el-input>
                    </el-form-item>
                    <el-form-item label="Secondary DNS Server :" prop="dns2">
                        <el-input v-model="lanIPv4Form.dns2"></el-input>
                    </el-form-item>
                </div>
                <hr>
                <el-form-item label="DHCP :">
                    <el-switch v-model="lanIPv4Form.dhcpEnable"></el-switch>
                </el-form-item>
                <div v-if="lanIPv4Form.dhcpEnable" key="DHCP">
                    <el-form-item label="Start (PC) :" prop="appendDhcpStart">
                        <el-input v-model="lanIPv4Form.appendDhcpStart" class="prepend-input">
                            <template slot="prepend" >{{prependIP}}.</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="End (PC) :" prop="appendDhcpEnd">
                        <el-input v-model="lanIPv4Form.appendDhcpEnd" class="prepend-input">
                            <template slot="prepend" >{{prependIP}}.</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="Lease Time :" prop="dhcpLeaseTime">
                        <el-input v-model.number="lanIPv4Form.dhcpLeaseTime" placeholder="Rang [1~604800]second">
                            <span slot="append">seconds</span>
                        </el-input>
                    </el-form-item>
                </div>
                <el-form-item>
                    <el-button type="info" class="dhcpReserved" @click="toDhcpReserved = true">Edit Reserved IP Address</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="apply">Apply</el-button>
                    <el-button type="primary" @click="refresh">Refresh</el-button>
                </el-form-item>
            </el-form>
        </div>    
        <DhcpReserved v-else v-on:back="toDhcpReserved = false"></DhcpReserved>
    </div>
</template>

<script>
import DhcpReserved from "./dhcpReserved"
import IpSubnetCalculator from "ip-subnet-calculator"
import devConfig from '@/devConfig'
export default {
    components:{
        DhcpReserved
    },
    data() {
        return {
            loading:false,
            isNotShowDNS:true, // TOT 不显示DNS配置
            toDhcpReserved:false,
            wanAddr:"0.0.0.0", //WAN 侧IP
            srcIPAddr:'',//原始IP
            lanIPv4Form: {
                ipAddr:'',
                mask:'',
                dnsMode:'2',
                dns1:'',
                dns2:'',
                dhcpEnable:true,
                dhcpStart:'',
                appendDhcpStart:'',
                dhcpEnd:'',
                appendDhcpEnd:'',
                dhcpLeaseTime:60
            },
            formCheck:{
                ipAddr:[
                    { required: true, message: 'IP Address cannot be empty.', trigger: 'blur' },
                    {
                        validator:(rule, value, callback) => {
                            if(!validator.isIP(value,4))
                                callback(new Error('IP Address error! e.g. 192.168.1.1'));
                            else if(this.wanAddr !== '0.0.0.0' && value === this.wanAddr)
                                callback(new Error(`IP Address conflict! this ${value} is WAN IP.`));
                            else
                                 callback()

                            this.lanIPv4Form.dhcpStart = `${this.prependIP}.${this.lanIPv4Form.appendDhcpStart}`
                            this.lanIPv4Form.dhcpEnd = `${this.prependIP}.${this.lanIPv4Form.appendDhcpEnd}`
                        },
                        trigger: 'blur'
                    }
                ],
                mask:[
                    { required: true, message: 'mask cannot be empty.', trigger: 'blur' },
                    {
                        validator:(rule, value, callback) => {
                            let mask_reg = /^(254|252|248|240|224|192|128|0)\.0\.0\.0|255\.(254|252|248|240|224|192|128|0)\.0\.0|255\.255\.(254|252|248|240|224|192|128|0)\.0|255\.255\.255\.(254|252|248|240|224|192|128|0)$/;
                            if(!mask_reg.test(value))
                                callback(new Error('mask error! e.g. 255.255.255.0'))
                            else
                                callback()
                        },
                        trigger: 'blur'
                    }
                ],
                dns1:[
                    { required: true, message: 'Primary DNS Server cannot be empty.', trigger: 'blur' },
                    {
                        validator:(rule, value, callback) => {
                            if(!validator.isIP(value,4))
                                callback(new Error('Primary DNS Server error! e.g. 192.168.1.1'));
                            else
                                callback()
                        },
                        trigger: 'blur'
                    }
                ],
                dns2:[
                    { required: true, message: 'Secondary DNS Server  cannot be empty.', trigger: 'blur' },
                    {
                        validator:(rule, value, callback) => {
                            if(!validator.isIP(value,4))
                                callback(new Error('Secondary DNS Server  error! e.g. 192.168.1.1'));
                            else
                                callback()
                        },
                        trigger: 'blur'
                    }
                ],
                appendDhcpStart:[
                    { required: true, message: 'Start IP(PC)  cannot be empty.', trigger: 'blur' },
                    {
                        validator:(rule, value, callback) => {
                            this.lanIPv4Form.dhcpStart = `${this.prependIP}.${parseInt(value || '0')}`

                            if(!IpSubnetCalculator.isIp(this.lanIPv4Form.dhcpStart))
                            {
                                callback(new Error('Start IP(PC) error!'))
                                return
                            }
                                
                            const ipCheck = IpSubnetCalculator.calculateCIDRPrefix( this.lanIPv4Form.ipAddr, this.lanIPv4Form.mask )
                            const sIPNum  = IpSubnetCalculator.toDecimal( this.lanIPv4Form.dhcpStart )
                            const eIPNum  = IpSubnetCalculator.toDecimal( this.lanIPv4Form.dhcpEnd )

                            if(sIPNum > ipCheck.ipHigh || sIPNum < ipCheck.ipLow)
                                 callback(new Error(`Start IP rang[${ipCheck.ipLowStr}-${ipCheck.ipHighStr}]`))
                            else if(sIPNum > eIPNum)
                                callback(new Error('Start IP must be less than or equal to the End IP!'))
                            else
                                callback()
                        },
                        trigger: 'blur'
                    },

                ],
                appendDhcpEnd:[
                    { required: true, message: 'End IP(PC)  cannot be empty.', trigger: 'blur' },
                    {
                        validator:(rule, value, callback) => {
                            
                            let endIP = parseInt(value || '0') 
                            this.lanIPv4Form.dhcpEnd = `${this.prependIP}.${endIP}`
                            if(!IpSubnetCalculator.isIp(this.lanIPv4Form.dhcpEnd))
                            {
                                callback(new Error('End IP(PC) error!'))
                                return
                            }

                            const ipCheck = IpSubnetCalculator.calculateCIDRPrefix( this.lanIPv4Form.ipAddr, this.lanIPv4Form.mask )
                            const sIPNum  = IpSubnetCalculator.toDecimal( this.lanIPv4Form.dhcpStart )
                            const eIPNum  = IpSubnetCalculator.toDecimal( this.lanIPv4Form.dhcpEnd )

                            if(eIPNum > ipCheck.ipHigh || eIPNum < sIPNum)
                                 callback(new Error(`End IP rang[${this.lanIPv4Form.dhcpStart}-${ipCheck.ipHighStr}]`))
                            else
                                callback()
                        },
                        trigger: 'blur'
                    },
                ],
                dhcpLeaseTime:[
                    { required: true, message: 'Lease Time cannot be empty.', trigger: 'blur' },
                    { type: 'number',min: 1, max: 604800, message: 'Lease Time range is [1-604800]min.', trigger: 'blur' }
                ]
            }
        }
    },
    created(){
        devConfig.init(this, () => {
            this.isNotShowDNS = devConfig.getData().area != 'TOT'
        })
        this.getData()
    },
    computed:{
        prependIP(){
            return this.lanIPv4Form.ipAddr.split('.',3).join('.')
        }
    },
    methods:{
        getData(){
            axios
            .post("/boafrm/fhGetInternetStatus")
            .then((response)=>{
                this.isLoad = false
                this.wanAddr = response.data.wanAddr
            })
            this.loading = true
            axios
            .post("/boafrm/fhLanIPv4",{CmdType:"GET_LAN_IPV4"})
            .then((response)=>{
                this.loading = false
                if(response.data.ret === 0)
                {
                    this.lanIPv4Form.ipAddr = response.data.lanIPv4.ipAddr
                    this.lanIPv4Form.mask = response.data.lanIPv4.mask
                    this.lanIPv4Form.dnsMode = response.data.lanIPv4.dnsMode
                    this.lanIPv4Form.dns1 = response.data.lanIPv4.dns1
                    this.lanIPv4Form.dns2 = response.data.lanIPv4.dns2
                    this.lanIPv4Form.dhcpEnable = response.data.lanIPv4.dhcpEnable
                    this.lanIPv4Form.dhcpStart = response.data.lanIPv4.dhcpStart
                    this.lanIPv4Form.dhcpEnd = response.data.lanIPv4.dhcpEnd
                    this.lanIPv4Form.dhcpLeaseTime = response.data.lanIPv4.dhcpLeaseTime
                    this.srcIPAddr = this.lanIPv4Form.ipAddr
                    this.lanIPv4Form.appendDhcpStart = this.lanIPv4Form.dhcpStart.split('.')[3] || '0'
                    this.lanIPv4Form.appendDhcpEnd = this.lanIPv4Form.dhcpEnd.split('.')[3] || '0'
                }
                else
                    this.$message.error(`GET data failed! Error:${response.data.errMsg}`)
            })
        },
        setData(){
            let loadingInstance = this.$loading({
                lock: true
            });
            let postData = {
                CmdType:"SET_LAN_IPV4",
                ip:this.lanIPv4Form.ipAddr,
                mask:this.lanIPv4Form.mask,
                dnsMode:this.lanIPv4Form.dnsMode,
                dns1:this.lanIPv4Form.dns1,
                dns2:this.lanIPv4Form.dns2,
                dhcpEnable:this.lanIPv4Form.dhcpEnable,
                dhcpStart:this.lanIPv4Form.dhcpStart,
                dhcpEnd:this.lanIPv4Form.dhcpEnd,
                dhcpLeaseTime:this.lanIPv4Form.dhcpLeaseTime
            }
            axios
            .post("/boafrm/fhLanIPv4",postData)
            .then((response)=>{
                setTimeout(() => {
                    
                    if(response.data.ret === 0)
                    {
                        if(this.lanIPv4Form.ipAddr != this.srcIPAddr)
                        {
                            setTimeout(()=>{
                                loadingInstance.close()
                                this.$alert(`The WEB management address has been modified. Please use the new address:${this.lanIPv4Form.ipAddr} Re-login to the management page.`, 'Warning', {
                                    confirmButtonText: 'Confirm',
                                    type:'warning',
                                    showClose:false,
                                    callback: action => {
                                        cookie.clear()
                                        // 跳转到登录页面
                                        window.location.href = `http://${this.lanIPv4Form.ipAddr}`
                                    }
                                });
                            },30000)
                            
                        }
                        else
                        {
                            loadingInstance.close()
                            this.$message.success("Configuration is successful!")
                        }
                            
                        
                    }
                    else
                    {
                        loadingInstance.close()
                        this.$message.error(`Configuration failed! Error:${response.data.errMsg}`)
                    }
                },5000)
                
                    
            })
        },
        apply(){
            this.$refs['lanIPv4Form'].validate((valid) => {
                if (valid) {
                    this.setData()
                } else {
                    console.log('error submit!!');
                    return false;
                }
            }); 
        },
        refresh(){
            this.$refs['lanIPv4Form'].resetFields()

            this.getData()
        }
    }
}
</script>

<style scoped>
.dhcpReserved{
    width: 100%;
}
.prepend-input>.el-input-group__prepend{
    width: 80%;
}
/* .fhv-form{
    width: 70%;
} */
</style>


